import {Injectable} from '@angular/core';
import {BarGraph, DonutGraph} from '../types/nso-data-portal/census-data';
import {TranslateService} from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class ChartDataTransformService {

  constructor() {
  }

  transformBarData(graphData: BarGraph) {
    graphData.labels = graphData.years.map(y => y.toString());
    delete graphData.years;
    graphData.datasets = this.transformDataList(graphData.dataList);
    delete graphData.dataList;
    graphData.totalsDeltas = [];
    Object.entries(graphData.totals).forEach(
      ([key, value]) => {
        graphData.totalsDeltas.push({total: graphData.totals[key], delta: graphData.deltas[key]});
      }
    );
  }

  transformLineData(graphData: BarGraph) {
    graphData.labels = graphData.years.map(y => y.toString());
    delete graphData.years;
    graphData.datasets = this.transformDataList(graphData.dataList);
    Object.entries(graphData.datasets).forEach(
      ([key, value]) => {
        if (value['data'].length < graphData.datasets.length) {
          value['data'].unshift(0);
        }
      }
    );
    delete graphData.dataList;
  }

  transformDonutData(graphData: DonutGraph) {
    graphData.datasets = [{data: []}];
    graphData.labels = graphData.labels.map(label => {
      graphData.datasets[0].data.push(graphData.values[label] || 0);
      return this.translateLabel(label);
    });
    delete graphData.values;
  }

  private translateLabel(label: string) {
    // return this.translate.instant('DATA_PORTAL.CENSUS.GRAPHS.' + label.toUpperCase());
    return label;
  }

  private transformDataList(list) {
    return list.map(entry => {
      entry.data = [];
      Object.entries(entry.amounts).forEach(
        ([key, value]) => entry.data.push(value)
      );
      entry.label = this.translateLabel(entry.label);
      delete entry.amounts;
      return entry;
    });
  }
}
